/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EpisodeRentalHistoryModel,
  GetRecentlyCompletedEpisodeInSeries200Response,
  GetSeriesBySeriesId404Response,
  LikedEpisodeModel,
  UserPointHistoriesSummaryModel,
  UserWalletResponseModel,
  ViewedSeriesModel,
} from '../models/index';
import {
    EpisodeRentalHistoryModelFromJSON,
    EpisodeRentalHistoryModelToJSON,
    GetRecentlyCompletedEpisodeInSeries200ResponseFromJSON,
    GetRecentlyCompletedEpisodeInSeries200ResponseToJSON,
    GetSeriesBySeriesId404ResponseFromJSON,
    GetSeriesBySeriesId404ResponseToJSON,
    LikedEpisodeModelFromJSON,
    LikedEpisodeModelToJSON,
    UserPointHistoriesSummaryModelFromJSON,
    UserPointHistoriesSummaryModelToJSON,
    UserWalletResponseModelFromJSON,
    UserWalletResponseModelToJSON,
    ViewedSeriesModelFromJSON,
    ViewedSeriesModelToJSON,
} from '../models/index';

export interface DeleteSeriesFromViewedHistoryRequest {
    seriesId: string;
    xComiciUserToken?: string;
}

export interface GetRecentlyCompletedEpisodeInSeriesRequest {
    seriesHash: string;
    xComiciUserToken?: string;
}

export interface GetRentalHistoriesRequest {
    xComiciUserTokenRequired: string;
    page?: number;
    size?: number;
}

export interface GetUserLikedEpisodesRequest {
    xComiciUserTokenRequired: string;
    page?: number;
    size?: number;
}

export interface GetUserPointHistoriesRequest {
    page?: number;
    size?: number;
    xComiciUserToken?: string;
}

export interface GetUserWalletRequest {
    xComiciUserTokenRequired: string;
}

export interface GetViewedSeriesHistoryRequest {
    xComiciUserTokenRequired: string;
    page?: number;
    size?: number;
}

/**
 * 
 */
export class UserApi extends runtime.BaseAPI {

    /**
     * 閲覧している作品の一覧から該当する作品を閲覧履歴から削除する
     * 作品閲覧履歴削除
     */
    async deleteSeriesFromViewedHistoryRaw(requestParameters: DeleteSeriesFromViewedHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.seriesId === null || requestParameters.seriesId === undefined) {
            throw new runtime.RequiredError('seriesId','Required parameter requestParameters.seriesId was null or undefined when calling deleteSeriesFromViewedHistory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/histories/series/{series_hash}/view`.replace(`{${"seriesId"}}`, encodeURIComponent(String(requestParameters.seriesId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 閲覧している作品の一覧から該当する作品を閲覧履歴から削除する
     * 作品閲覧履歴削除
     */
    async deleteSeriesFromViewedHistory(requestParameters: DeleteSeriesFromViewedHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSeriesFromViewedHistoryRaw(requestParameters, initOverrides);
    }

    /**
     * 省略的な読了済みの話を取得する
     * エピソード読了履歴取得
     */
    async getRecentlyCompletedEpisodeInSeriesRaw(requestParameters: GetRecentlyCompletedEpisodeInSeriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRecentlyCompletedEpisodeInSeries200Response>> {
        if (requestParameters.seriesHash === null || requestParameters.seriesHash === undefined) {
            throw new runtime.RequiredError('seriesHash','Required parameter requestParameters.seriesHash was null or undefined when calling getRecentlyCompletedEpisodeInSeries.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/histories/series/{series_hash}/read`.replace(`{${"series_hash"}}`, encodeURIComponent(String(requestParameters.seriesHash))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRecentlyCompletedEpisodeInSeries200ResponseFromJSON(jsonValue));
    }

    /**
     * 省略的な読了済みの話を取得する
     * エピソード読了履歴取得
     */
    async getRecentlyCompletedEpisodeInSeries(requestParameters: GetRecentlyCompletedEpisodeInSeriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRecentlyCompletedEpisodeInSeries200Response> {
        const response = await this.getRecentlyCompletedEpisodeInSeriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * レンタル（購入）履歴一覧を取得します。
     * レンタル履歴取得
     */
    async getRentalHistoriesRaw(requestParameters: GetRentalHistoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EpisodeRentalHistoryModel>>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling getRentalHistories.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/histories/rental`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EpisodeRentalHistoryModelFromJSON));
    }

    /**
     * レンタル（購入）履歴一覧を取得します。
     * レンタル履歴取得
     */
    async getRentalHistories(requestParameters: GetRentalHistoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EpisodeRentalHistoryModel>> {
        const response = await this.getRentalHistoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ユーザーによりのエピソードのいいね履歴一覧を返します。  ユーザーのトークンを X-Comici-Access-Token として渡します。
     * いいね履歴取得
     */
    async getUserLikedEpisodesRaw(requestParameters: GetUserLikedEpisodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LikedEpisodeModel>>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling getUserLikedEpisodes.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/histories/likes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LikedEpisodeModelFromJSON));
    }

    /**
     * ユーザーによりのエピソードのいいね履歴一覧を返します。  ユーザーのトークンを X-Comici-Access-Token として渡します。
     * いいね履歴取得
     */
    async getUserLikedEpisodes(requestParameters: GetUserLikedEpisodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LikedEpisodeModel>> {
        const response = await this.getUserLikedEpisodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * コイン獲得・使用履歴一覧を取得
     * コイン&チケット獲得・消費履歴
     */
    async getUserPointHistoriesRaw(requestParameters: GetUserPointHistoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserPointHistoriesSummaryModel>>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/histories/wallet`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserPointHistoriesSummaryModelFromJSON));
    }

    /**
     * コイン獲得・使用履歴一覧を取得
     * コイン&チケット獲得・消費履歴
     */
    async getUserPointHistories(requestParameters: GetUserPointHistoriesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserPointHistoriesSummaryModel>> {
        const response = await this.getUserPointHistoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 下記の情報を返却します * 現在保有コイン * 現在保有ボーナスチケット * 直近で期限となるコインまたはチケットの情報
     * 保有コイン&チケット情報取得
     */
    async getUserWalletRaw(requestParameters: GetUserWalletRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserWalletResponseModel>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling getUserWallet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/wallet`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserWalletResponseModelFromJSON(jsonValue));
    }

    /**
     * 下記の情報を返却します * 現在保有コイン * 現在保有ボーナスチケット * 直近で期限となるコインまたはチケットの情報
     * 保有コイン&チケット情報取得
     */
    async getUserWallet(requestParameters: GetUserWalletRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserWalletResponseModel> {
        const response = await this.getUserWalletRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ログインしているユーザーが閲覧されている作品の一覧を取得します。  取得される一覧はログインしているユーザーが閲覧されている作品の概要情報のみを含みます。エピソードを含む情報は、取得したい作品の作品IDを元に取得します。
     * 作品閲覧履歴取得
     */
    async getViewedSeriesHistoryRaw(requestParameters: GetViewedSeriesHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ViewedSeriesModel>>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling getViewedSeriesHistory.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/histories/series/view`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ViewedSeriesModelFromJSON));
    }

    /**
     * ログインしているユーザーが閲覧されている作品の一覧を取得します。  取得される一覧はログインしているユーザーが閲覧されている作品の概要情報のみを含みます。エピソードを含む情報は、取得したい作品の作品IDを元に取得します。
     * 作品閲覧履歴取得
     */
    async getViewedSeriesHistory(requestParameters: GetViewedSeriesHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ViewedSeriesModel>> {
        const response = await this.getViewedSeriesHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
